import { versionMatches, cosineSimilarityCondition, logisticRegressionCondition, } from './conditions';
export var queryMatches = function (query, pageFeatures) {
    if (!pageFeatures || !versionMatches(query, pageFeatures)) {
        return false;
    }
    // matches if any of the conditions are satisfied
    return [
        cosineSimilarityCondition,
        logisticRegressionCondition,
    ].some(function (match) { return match(query, pageFeatures); });
};
//# sourceMappingURL=index.js.map